import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Message } from './message';
import { MessageService } from '../../services/message.service';
import { Subscriber } from 'rxjs/Subscriber';
import { MessageType } from './message-type';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
})
export class MessageComponent implements OnInit, OnDestroy {
  message: Message;
  errorMessage: boolean;
  infoMessage: boolean;

  private onMessageSubscriber: Subscriber<Message>;

  @ViewChild(ModalComponent) modalComponent: ModalComponent;

  constructor(messageService: MessageService) {
    this.onMessageSubscriber = messageService.onMessage
      .subscribe(message => this.onMessage(message));
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.onMessageSubscriber.unsubscribe();
  }

  private onMessage(message: Message) {
    this.message = message;

    this.errorMessage = message.type === MessageType.Error;
    this.infoMessage = message.type === MessageType.Info;

    this.modalComponent.openModal();
  }

  onCloseButtonClick() {
    this.modalComponent.closeModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/message/message.component.ts